'use client'

import { useEffect } from 'react'
import {
  allowAnalyticsCookies,
  COOKIE_CONSENT_CHANGE_EVENT,
  getGaMeasurementId,
  type CookieConsentChoice,
} from '@/lib/cookieConsent'

declare global {
  interface Window {
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}

function loadGoogleAnalytics(measurementId: string): void {
  if (typeof window === 'undefined' || window.gtag) return

  window.dataLayer = window.dataLayer || []
  function gtag(...args: unknown[]) {
    window.dataLayer?.push(args)
  }
  window.gtag = gtag
  gtag('js', new Date())
  gtag('config', measurementId, { anonymize_ip: true })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`
  document.head.appendChild(script)
}

/** Loads GA only after the user chooses “Accept all”. */
export default function CookieConsentAnalytics() {
  useEffect(() => {
    const measurementId = getGaMeasurementId()
    if (!measurementId) return

    if (allowAnalyticsCookies()) {
      loadGoogleAnalytics(measurementId)
    }

    const onConsent = (event: Event) => {
      const detail = (event as CustomEvent<CookieConsentChoice>).detail
      if (detail === 'all') loadGoogleAnalytics(measurementId)
    }

    window.addEventListener(COOKIE_CONSENT_CHANGE_EVENT, onConsent)
    return () => window.removeEventListener(COOKIE_CONSENT_CHANGE_EVENT, onConsent)
  }, [])

  return null
}
